import * as React from "react";
import { Table } from "../../newcomponents/table/table";
import { DateString } from "../../components/dateString";
import { formatStrings } from "../../utils/time";
import { HelmReleaseInstance, ReleaseRevision } from "../marketplace/types/release";

interface Props {
  release: HelmReleaseInstance;
  revisions: ReleaseRevision[];
}
export const ReleaseRevisions: React.FC<Props> = ({ release, revisions }) => {
  const revisionTableItems: ReleaseRevision[] = revisions
    .toSorted((a, b) => {
      if (a.version > b.version) return -1;
      if (b.version > a.version) return 1;
      return 0;
    })
    .map((d) => {
      return {
        ...d,
      };
    });

  return (
    <>
      <Table<ReleaseRevision>
        columns={[
          {
            id: "version",
            label: "Revision",
            size: 100,
          },
          {
            id: "info.description",
            label: "Description",
          },
          {
            id: "info.status",
            label: "Status",
          },
          {
            id: "info.lastDeployed",
            label: "Updated",
            cell: ({ getValue }) => {
              return <DateString iso={getValue()} format={formatStrings.log} />;
            },
          },
        ]}
        data={revisionTableItems}
        title={"Revisions"}
        tableId="release-revisions-update2"
        hideSettings
      />
    </>
  );
};
